@if(hasMessages$ | async){
<mat-toolbar class="messages">
  @for (message of messages; track message) {
  <mat-toolbar-row
    class="messages__row"
    [class.messages__row--error]="message.type === 'error'"
    [class.messages__row--warn]="message.type === 'warn'"
    [class.messages__row--info]="message.type === 'info'"
    (click)="handleClick(message)"
  >
    @if(message.icon) {
    <mat-icon
      class="messages__icon"
      aria-hidden="false"
      [ariaLabel]="message.label"
    >
      {{ message.icon }}
    </mat-icon>
    <span class="messages__spacer"></span>
    }
    {{ message.message }}
  </mat-toolbar-row>
  }
</mat-toolbar>
}
